var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 40,
    viewBox: "0 0 166 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_162_1076)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_162_1076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.4367 25.4147C33.3933 23.7544 31.4252 22.1539 29.4218 20.5273C29.5216 20.4354 29.5969 20.3664 29.6599 20.3096C30.5971 20.5641 31.4774 20.374 32.3486 20.1333C33.5469 19.8022 34.561 19.1583 35.3614 18.2155C36.3063 17.1041 36.8363 15.8316 36.8671 14.3385C36.8963 12.8422 36.4968 11.5008 35.6764 10.2698C34.7853 8.93451 33.5623 8.10054 31.9537 7.87365C31.5788 7.81999 31.1993 7.76634 30.8214 7.76634C23.5051 7.7602 16.1889 7.75867 8.87417 7.7694C8.3687 7.7694 7.99382 7.63603 7.60973 7.28343C6.84154 6.5767 5.99653 5.95122 5.193 5.28282C4.65066 4.8321 4.12675 4.35686 3.58441 3.90615C3.02977 3.44471 2.45056 3.01392 1.90668 2.54175C1.67161 2.33785 1.37662 2.15389 1.2998 1.74917C1.47803 1.7323 1.61323 1.70931 1.74996 1.70931C11.529 1.70778 21.3081 1.70011 31.0872 1.72157C32.0152 1.72311 32.9462 1.89787 33.8511 2.14929C35.1924 2.52335 36.4338 3.1105 37.5753 3.90002C38.4541 4.5071 39.2408 5.2077 39.9444 6.02787C41.0752 7.34782 41.8618 8.8318 42.3904 10.466C42.6055 11.1298 42.796 11.7998 42.8175 12.5096C42.8344 13.0522 42.8958 13.5934 42.922 14.1361C42.9896 15.5772 42.7038 16.9615 42.2198 18.3121C41.7313 19.6734 41.0015 20.8876 40.0827 22.0113C38.9519 23.3941 37.5769 24.4366 35.9775 25.2077C35.8039 25.292 35.6164 25.3487 35.4398 25.4162L35.4367 25.4147Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_162_1076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0209 35.7167C29.6721 35.1372 29.348 34.5408 28.9685 33.9828C28.2141 32.8714 27.4582 31.7584 26.6501 30.6868C26.0632 29.908 25.3764 29.2059 24.7634 28.4455C23.7755 27.2206 22.6709 26.1045 21.5339 25.0238C20.7074 24.2373 19.8116 23.5244 18.9589 22.7656C17.4349 21.4135 15.7879 20.2207 14.0779 19.1231C12.8472 18.3336 11.5613 17.6253 10.2861 16.9063C9.46257 16.4418 8.61909 16.0095 7.75411 15.6278C6.09174 14.895 4.40326 14.2235 2.71631 13.5474C2.31685 13.388 1.89742 13.2838 1.48413 13.1611C1.35968 13.1243 1.24907 13.0477 1.1323 12.9863C1.14152 12.9496 1.15227 12.9143 1.16149 12.8775C1.87591 12.968 2.59186 13.0553 3.30628 13.1519C3.82404 13.2209 4.34027 13.2899 4.85496 13.3788C5.89816 13.5582 6.94597 13.7161 7.97842 13.9445C10.2308 14.4427 12.4278 15.1326 14.5972 15.9144C15.5374 16.2532 16.4654 16.6319 17.3795 17.0351C18.4443 17.5042 19.5044 17.9902 20.5414 18.5191C22.7461 19.6428 24.8571 20.9305 26.8867 22.3425C27.9499 23.0814 28.9362 23.9292 29.9625 24.7217C32.0397 26.3238 33.8496 28.214 35.6487 30.1012C37.1159 31.6403 38.4587 33.3129 39.5864 35.1341C40.0043 35.8087 40.5052 36.4265 40.9984 37.0474C41.1121 37.1899 41.1858 37.354 41.2933 37.5395C41.1766 37.6054 41.0921 37.6774 40.9953 37.702C40.8908 37.728 40.7756 37.7096 40.6665 37.7096C34.4534 37.7096 28.2402 37.7096 22.0271 37.7096C17.7852 28.5375 10.8284 22.5832 1.05548 19.8758C1.28747 19.8911 1.51947 19.9019 1.74993 19.9218C1.98346 19.9417 2.2216 19.9494 2.45052 19.9969C3.46607 20.207 4.48315 20.4185 5.49409 20.6485C7.62198 21.1329 9.6961 21.7814 11.7303 22.5801C13.4495 23.2546 15.1533 23.9583 16.7727 24.8398C18.2507 25.6446 19.7133 26.4817 21.0592 27.5057C21.8243 28.0868 22.6171 28.6325 23.3853 29.2089C23.6925 29.4389 23.9845 29.6903 24.2625 29.954C25.5208 31.1421 26.7715 32.3394 28.0129 33.5459C28.6289 34.1453 29.1406 34.8352 29.6506 35.5266C29.7275 35.6308 29.8427 35.7075 29.941 35.7964C29.9886 35.8792 30.0363 35.9635 30.0839 36.0463C30.11 36.0356 30.1346 36.0248 30.1607 36.0126C30.1131 35.9144 30.0655 35.8179 30.0194 35.7198L30.0209 35.7167ZM30.2975 36.0647C30.2667 36.0785 30.236 36.0938 30.2053 36.1076C30.2252 36.1536 30.2468 36.1981 30.2667 36.244C30.2882 36.2379 30.3097 36.2303 30.3328 36.2241C30.3205 36.1705 30.3097 36.1183 30.2975 36.0647Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_162_1076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.004 21.4134V24.8061H93.7608C93.5104 25.0222 93.4474 25.2506 93.4474 25.5205C93.452 28.3075 93.4505 31.0961 93.4505 33.8694C93.6563 34.1867 93.9344 34.3002 94.2924 34.2986C97.1055 34.2925 99.9171 34.291 102.73 34.2986C103.088 34.2986 103.365 34.1913 103.589 33.9062V31.625C103.4 31.2908 103.076 31.2065 102.686 31.208C100.701 31.2157 98.7157 31.2126 96.6907 31.2126V27.8369H106.994C107.003 27.9779 107.02 28.1358 107.02 28.2937C107.021 30.7144 107.006 33.1366 107.029 35.5572C107.038 36.4786 106.285 37.3693 105.411 37.5885C105.082 37.6713 104.732 37.702 104.393 37.702C100.991 37.7096 97.591 37.7081 94.1895 37.7066C92.8006 37.7066 91.6406 37.1731 90.7987 36.0815C90.3178 35.4591 90.0213 34.7263 90.0259 33.8954C90.0382 30.8508 90.0366 27.8062 90.0259 24.7601C90.0228 23.92 90.3562 23.2209 90.8801 22.6077C91.5899 21.7783 92.4994 21.3996 93.6087 21.4042C97.8553 21.4226 102.102 21.4119 106.348 21.4119H107.004V21.4134Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_162_1076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.744 21.4134V24.7953C123.445 24.8582 122.184 24.8168 120.924 24.8245C119.657 24.8321 118.387 24.826 117.12 24.826H113.287C113.195 24.9072 113.089 25.0023 112.99 25.0897V27.5594C113.053 27.6161 113.159 27.7112 113.287 27.8246H124.742C124.837 28.9499 124.759 30.0414 124.793 31.2111H124.197C120.76 31.2111 117.323 31.2111 113.886 31.2111C113.729 31.2111 113.572 31.1942 113.42 31.2279C113.168 31.2831 112.995 31.5177 112.989 31.7752C112.972 32.4268 112.972 33.0783 112.989 33.7299C112.995 33.9874 113.168 34.2204 113.42 34.2772C113.572 34.3109 113.731 34.294 113.886 34.294C117.304 34.294 120.723 34.294 124.143 34.294H124.756V37.6498C124.591 37.6713 124.453 37.705 124.315 37.705C120.786 37.7081 117.257 37.7526 113.728 37.6897C111.798 37.656 110.341 36.543 109.716 34.5868C109.602 34.2327 109.57 33.8418 109.569 33.4662C109.556 30.8799 109.559 28.2937 109.564 25.709C109.564 24.7907 109.782 23.9215 110.34 23.1826C111.159 22.0956 112.2 21.4042 113.634 21.4104C117.126 21.4242 120.618 21.415 124.111 21.415H124.747L124.744 21.4134Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_162_1076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.418 21.4135V24.8291H130.826C130.675 25.3058 130.76 25.7458 130.746 26.1751C130.732 26.615 130.743 27.055 130.743 27.5441C130.823 27.6054 130.923 27.682 131.072 27.797H142.401V31.182H131.075C130.974 31.2755 130.886 31.3567 130.808 31.4303C130.777 32.4345 130.76 32.9894 130.729 33.9936L131.013 34.291H142.4V37.682C142.257 37.6912 142.098 37.7081 141.94 37.7081C138.447 37.7096 134.953 37.7311 131.459 37.7004C129.546 37.6836 127.821 36.31 127.435 34.4826C127.372 34.1852 127.328 33.877 127.326 33.5735C127.318 30.8953 127.337 28.2155 127.312 25.5373C127.305 24.6528 127.583 23.8878 128.051 23.1642C128.594 22.3271 129.397 21.8304 130.337 21.5468C130.626 21.4594 130.927 21.4242 131.23 21.4227C134.764 21.4104 138.296 21.415 141.83 21.415H142.417L142.418 21.4135Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_162_1076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.4085 34.8674C48.9753 35.8133 48.5451 36.753 48.1164 37.6897H44.3446C44.4921 37.3356 44.6165 37.009 44.761 36.6917C45.2081 35.7167 45.6597 34.7432 46.1161 33.7728C46.7767 32.3639 47.4404 30.9566 48.1087 29.5508C48.8001 28.096 49.4976 26.6442 50.1982 25.1939C50.4855 24.5991 50.7805 24.0089 51.0816 23.4233C51.5472 22.5188 52.363 22.0021 53.2602 21.6618C54.4525 21.2111 55.7 21.2555 56.8523 21.7768C58.0568 22.3225 58.8665 23.3144 59.3044 24.5899C59.3213 24.6374 59.3397 24.6834 59.3612 24.7294C59.9942 26.0356 60.6333 27.3371 61.2617 28.6448C61.9976 30.1778 62.7305 31.7109 63.4511 33.25C64.0118 34.4473 64.5542 35.6523 65.0981 36.8573C65.2118 37.1102 65.3731 37.3616 65.287 37.6851H61.6765C61.2448 36.7499 60.8116 35.8102 60.3768 34.8674H49.407H49.4085ZM58.6606 31.0946C58.3549 30.371 58.1075 29.7133 57.728 29.0541C57.2026 28.1389 56.7816 27.1715 56.4405 26.1735C56.1486 25.3166 55.7215 24.7831 54.8366 24.6022C54.5539 24.7233 54.2266 24.8628 53.8533 25.0222C52.9468 27.0274 52.0342 29.0449 51.1078 31.093H58.6606V31.0946Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_162_1076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.0709 33.1397V21.4518H87.4571C87.4678 21.5545 87.4909 21.6756 87.4909 21.7967C87.4924 26.3621 87.4847 30.9275 87.4986 35.4929C87.5016 36.3912 86.6243 37.4383 85.7932 37.61C84.2107 37.9381 83.0477 37.4168 82.1642 36.2502C82.0536 36.103 81.8508 35.8792 81.7233 35.7474C80.5065 34.4964 79.2866 33.2485 78.0728 31.9929C77.426 31.3245 76.793 30.6423 76.1524 29.9678C75.4349 29.2136 74.7159 28.4624 73.9984 27.7081C73.3439 27.0213 72.6894 26.3345 72.041 25.6416C71.8244 25.4086 71.6308 25.1541 71.3711 24.8429C71.1975 25.312 71.3312 25.7152 71.2467 26.1183H67.882V21.7553C67.9696 21.6848 68.1109 21.5729 68.3091 21.4135C69.6289 21.4135 71.0239 21.4165 72.419 21.4119C72.7769 21.4119 73.0135 21.6388 73.2517 21.8442C73.4422 22.0083 73.5866 22.226 73.7618 22.4084C74.9187 23.6042 76.0832 24.7953 77.2386 25.9926C77.91 26.6886 78.5722 27.3938 79.2374 28.0944C79.9288 28.8226 80.6217 29.5493 81.3131 30.2759C82.0183 31.0164 82.7266 31.7523 83.4256 32.4988C83.6238 32.7104 83.7913 32.9496 83.9741 33.1749L84.0709 33.1397Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_162_1076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.362 24.7953H145.024C144.925 24.2205 144.987 23.6747 144.976 23.1335C144.965 22.5847 144.973 22.0359 144.973 21.4119H149.931C150.619 22.1509 151.328 22.9112 152.037 23.6701C152.062 23.6977 152.09 23.7222 152.114 23.7483C153.274 24.9425 154.437 26.1352 155.594 27.331C156.381 28.145 157.163 28.9652 157.945 29.7854C158.599 30.4722 159.255 31.1574 159.902 31.8519C160.308 32.2873 160.696 32.738 161.187 33.1366V21.438H164.587V37.4414C164.53 37.4996 164.444 37.5916 164.336 37.7035C163.248 37.7035 162.147 37.7004 161.045 37.705C160.746 37.705 160.534 37.5548 160.342 37.3509C159.728 36.7009 159.115 36.0494 158.498 35.4024C158.27 35.1633 158.028 34.9379 157.797 34.7003C156.779 33.6502 155.76 32.6 154.746 31.5453C154.076 30.8478 153.414 30.1426 152.747 29.442C152.042 28.7015 151.334 27.9641 150.633 27.2206C149.882 26.4234 149.137 25.6201 148.362 24.7923V24.7953Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_162_1076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.998 37.6744V26.4985C145.356 26.3437 147.493 26.2977 148.276 26.4188C148.431 26.7898 148.502 35.9282 148.361 37.6744H144.998Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_162_1076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.2405 27.8231H67.8973V37.6652H71.2405V27.8231Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_162_1076",
    x: -2.7002,
    y: -2.29327,
    width: 49.632,
    height: 31.7095,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.62 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_162_1076"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_162_1076",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_162_1076",
    x: -2.94452,
    y: 8.8775,
    width: 48.2379,
    height: 32.8384,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.62 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_162_1076"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_162_1076",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_162_1076",
    x: 86.0258,
    y: 17.4042,
    width: 25.0033,
    height: 24.3036,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.62 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_162_1076"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_162_1076",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_162_1076",
    x: 105.56,
    y: 17.4103,
    width: 23.2327,
    height: 24.3128,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.62 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_162_1076"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_162_1076",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_162_1076",
    x: 123.312,
    y: 17.4135,
    width: 23.1059,
    height: 24.3034,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.62 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_162_1076"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_162_1076",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_162_1076",
    x: 40.3446,
    y: 17.3524,
    width: 28.9667,
    height: 24.3373,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.62 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_162_1076"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_162_1076",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_162_1076",
    x: 63.882,
    y: 17.4119,
    width: 27.6166,
    height: 24.2946,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.62 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_162_1076"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_162_1076",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_162_1076",
    x: 140.967,
    y: 17.4119,
    width: 27.6196,
    height: 24.2931,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.62 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_162_1076"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_162_1076",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_162_1076",
    x: 140.998,
    y: 22.3499,
    width: 11.4394,
    height: 19.3245,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.62 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_162_1076"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_162_1076",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_162_1076",
    x: 63.8973,
    y: 23.8231,
    width: 11.3431,
    height: 17.8421,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.62 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_162_1076"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_162_1076",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_162_1076"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 166,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.5390fbf010c18708276faee1c9e15b3e.svg";
export { ForwardRef as ReactComponent };